import React from "react";

import { SOUNDMACHINE_VIDEO_URL } from "../utils";
import { VimeoContainer } from "../components";

export default function Soundmachine() {
  return (
    <div className="py-navbar">
      <div className="flex flex-column flex-wrap items-center block-font col-12 px1">
        <div>
          <div className="flex flex-column center items-center my4">
            <div className="h0 mb1">Listen to the Data</div>
            <div className="color-gray h2">
              Experience a sonic rendering of the dataset, produced by Brian
              Eno.
            </div>
          </div>
        </div>
      </div>
      <VimeoContainer
        url={SOUNDMACHINE_VIDEO_URL}
        className="pointer full-height-minus-navbar"
      />
    </div>
  );
}
